import {
  Button,
  Container,
  MtLayoutTitleWrapper,
  Pagination,
  PaginationWrapper,
} from '@presentation/components';
import dayjs from 'dayjs';
import type { FC } from 'react';
import { FaComments } from 'react-icons/fa';
import * as Styled from './styled';
import type { MtWaitingListPageProps } from './types';

export * from './types';

export const MtWaitingListPage: FC<MtWaitingListPageProps> = (props) => {
  const { onAddClick } = props;

  return (
    <Container>
      <MtLayoutTitleWrapper>
        Liste d&apos;attente
        <Button color="blue" onClick={onAddClick}>
          Ajouter un membre
        </Button>
      </MtLayoutTitleWrapper>
      <Styled.Table>
        <thead>
          <Styled.TableHeaderRow>
            <Styled.TableHeaderCell width={80}>#</Styled.TableHeaderCell>
            <Styled.TableHeaderCell>Nom</Styled.TableHeaderCell>
            <Styled.TableHeaderCell>Ajouté le</Styled.TableHeaderCell>
            <Styled.TableHeaderCell>Portée</Styled.TableHeaderCell>
            <Styled.TableHeaderCell>Statut de paiement</Styled.TableHeaderCell>
            <Styled.TableHeaderCell width={120}>Messages</Styled.TableHeaderCell>
          </Styled.TableHeaderRow>
        </thead>
        <tbody>
          {new Array(15).fill(0).map((_, index) => (
            <Styled.TableRow key={index}>
              <Styled.TableCell>{index + 1}</Styled.TableCell>
              <Styled.TableCell>
                <Styled.NameSpan>John Smith</Styled.NameSpan>
              </Styled.TableCell>
              <Styled.TableCell>{dayjs().format('DD/MM/YYYY')}</Styled.TableCell>
              <Styled.TableCell>Louna & Kiara</Styled.TableCell>
              <Styled.TableCell>
                <Styled.Tag>En attente adoptant</Styled.Tag>
              </Styled.TableCell>
              <Styled.TableCell>
                <Styled.MessageIconWrapper>
                  <FaComments />
                  <Styled.MessageTag>3</Styled.MessageTag>
                </Styled.MessageIconWrapper>
              </Styled.TableCell>
            </Styled.TableRow>
          ))}
        </tbody>
      </Styled.Table>
      <PaginationWrapper>
        <Pagination
          initialPage={0}
          marginPagesDisplayed={0}
          pageRangeDisplayed={2}
          pageCount={12}
        />
      </PaginationWrapper>
    </Container>
  );
};
